import apiRepository from 'Repositories/apiRepository';

export const SupplierService = {
    async getAllSuppliers() {
        try {
            const response = await apiRepository.get('/suppliers');
            return response.data.data;
        } catch (err) {

        }
    },

    async getAllPaginated(limit, page) {
        try {
            const response = await apiRepository.get(`/suppliers?limit=${limit}&page=${page}`);
            return response.data;
        } catch (err) {
            return {
                data: [],
                total: 0,
            }
        }
    },

    async searchAll(query, limit, page) {
        try {
            const response = await apiRepository.get(`/suppliers?query=${query}&limit=${limit}&page=${page}`);
            return response.data;
        } catch (err) {
            return {
                data: [],
                total: 0,
            }
        }
    },

    async createSupplier(supplier) {
        try {
            const response = await apiRepository.post('/suppliers', supplier);
            return response.data.data;
        } catch (err) {

        }
    },

    async updateSupplier(supplier) {
        try {
            const response = await apiRepository.post(`/suppliers/${supplier._id}`, supplier);
            return response.data.data;
        } catch (err) {

        }
    },

    async deleteSupplier(supplierId) {
        try {
            const response = await apiRepository.delete(`/suppliers/${supplierId}`);
            return response.data.data;
        } catch (err) {

        }
    }
};
